module.exports = __webpack_public_path__ + "fonts/ProximaNova-Semibold.d1ac85ea.woff2";